import React, {Component} from 'react'
import IgniteDataTable from '../../../common/datatable'
import {dateTimeFormat} from '../../../../utils/commonFunctions'
import {history} from '../../../../store';

class PpcUsersList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const columns = [
      {
        prop:  'user-id',
        title: 'User ID',
        width: '75',
        onClick(data, row) {history.push(`/admin/users/${data}/details`)}
      },
      {prop: 'first-name', title: 'First Name'},
      {prop: 'last-name', title: 'Last Name'},
      {prop: 'email', title: 'Email'},
      {prop: 'mobile', title: 'Mobile', width: '120'},
      {prop: 'created-at', title: 'Opt in date', format(data, row) {return dateTimeFormat(data)}},
      {prop: 'kyc-status', title: 'KYC status', width: '100'},
      {prop: 'account-number', title: 'PPC acc#', width: '100'},
    ];

    const actions = [
      {
        label:       'View',
        permissions: {
          action: 'manage',
          subjectClass: 'PpcUser',
          mode: 'disable'
        },
        callback:    (row) => {
          history.push(`/admin/ppc/management/${row.id}`);
        }
      },
    ];

    return (
      <IgniteDataTable data={this.props.users}
                       dataSize={this.props.pagination.number * this.props.pagination.size}
                       hideId={false}
                       columns={columns}
                       actions={actions}
                       pagination={{
                         onPageChange: this.props.onPageChange,
                         page: this.props.currentPage,
                         sizePerPage: 20,
                       }}
                       remote/>
    )
  }
}

export default PpcUsersList


// WEBPACK FOOTER //
// ./src/components/admin/ppc/management/ppc-list.jsx